var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class:
        _vm.soundOnly && !_vm.isScreenSharing && !_vm.isCalling
          ? "soundOnly"
          : "",
      style: {
        left: _vm.x ? "calc(" + _vm.x + "px)" : 0,
        top: _vm.y ? "calc(" + _vm.y + "px)" : 0,
      },
      attrs: { id: "videocall" },
    },
    [
      !_vm.remoteVideoEnabled && !_vm.isCalling
        ? _c(
            "div",
            { staticClass: "vcthumbnail h-100 d-flex" },
            [
              _c(
                "a-avatar",
                {
                  staticStyle: {
                    "background-color": "rgb(49 50 52) !important",
                    color: "white",
                    "font-size": "25px",
                    margin: "80px auto",
                  },
                  attrs: {
                    size: 100,
                    username: _vm.getConversation().fullname,
                  },
                },
                [_vm._v(_vm._s(_vm.getConversation().fullname) + "\n        ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "header" }, [
        !_vm.isFullScreen
          ? _c(
              "button",
              {
                staticClass: "videocall-btn move-cursor",
                on: {
                  mousedown: function ($event) {
                    _vm.isMouseDown = true
                  },
                  mouseup: function ($event) {
                    _vm.isMouseDown = false
                  },
                },
              },
              [_c("md-icon", [_vm._v("open_with")])],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isFullScreen && (!_vm.soundOnly || _vm.isScreenSharing)
          ? _c(
              "button",
              {
                staticClass: "videocall-btn",
                on: {
                  click: function ($event) {
                    return _vm.closeFullScreen()
                  },
                },
              },
              [_c("md-icon", [_vm._v("close_fullscreen")])],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.isFullScreen && (!_vm.soundOnly || _vm.isScreenSharing)
          ? _c(
              "button",
              {
                staticClass: "videocall-btn",
                on: {
                  click: function ($event) {
                    return _vm.makeFullScreen()
                  },
                },
              },
              [_c("md-icon", [_vm._v("fullscreen")])],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.isCalling
        ? _c(
            "div",
            { staticClass: "calling" },
            [
              _c(
                "a-avatar",
                {
                  staticStyle: {
                    "background-color": "rgb(49 50 52) !important",
                    color: "white",
                    "font-size": "25px",
                  },
                  attrs: { size: 100 },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.getConversation().fullname.substr(0, 1).toUpperCase()
                    ) + "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("strong", { staticClass: "p-3" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.getConversation().fullname) +
                    " Aranıyor .... "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "callingToolbox" },
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "md-icon-button md-fab",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.reject.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("md-icon", { staticStyle: { color: "white" } }, [
                        _vm._v("call_end"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.remoteVideoEnabled,
            expression: "remoteVideoEnabled",
          },
        ],
        key: "video_display",
        attrs: { id: "video_display" },
      }),
      _vm._v(" "),
      !_vm.soundOnly
        ? _c("div", {
            key: "video_self",
            style: _vm.selfVideoPositions[_vm.currentSelfPosition],
            attrs: { id: "video_self" },
            on: { dblclick: _vm.changeSelfPosition },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isAnswered()
        ? _c(
            "div",
            { staticClass: "controlBox" },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-icon-button md-primary play-sound-button",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.askScreenShare.apply(null, arguments)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("screen_share")])],
                1
              ),
              _vm._v(" "),
              !_vm.soundOnly
                ? _c(
                    "md-button",
                    {
                      staticClass:
                        "md-icon-button md-primary play-sound-button",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.toggleVideoCam.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("md-icon", [
                        _vm._v(
                          _vm._s(_vm.videoEnabled ? "videocam" : "videocam_off")
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "md-button",
                {
                  staticClass: "md-icon-button md-primary play-sound-button",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.toggleMic.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("md-icon", [
                    _vm._v(_vm._s(_vm.micEnabled ? "mic" : "mic_off")),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-button",
                {
                  staticClass: "md-icon-button md-primary play-sound-button",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.cancelVideoCall.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("md-icon", { staticStyle: { color: "red" } }, [
                    _vm._v("cancel"),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }